module.exports = __webpack_public_path__ + "static/media/Sign-Up.b0201d83.svg";